// src/components/ExtraCitiesSelector.jsx
import React from "react";
import { TextField, Button, MenuItem, Chip } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

export default function ExtraCitiesSelector({
  extraCityInput,
  customExtraCity,
  selectedExtraCities,
  availableExtraCities,
  handleAddExtraCity,
  handleRemoveExtraCity,
  handleChange,
}) {
  return (
    <>
      <TextField
        fullWidth
        label="Selecciona ciudad"
        select
        name="extraCityInput"
        value={extraCityInput}
        onChange={handleChange}
      >
        {availableExtraCities.map((city) => (
          <MenuItem key={city} value={city}>
            {city}
          </MenuItem>
        ))}
      </TextField>

      {extraCityInput === "Otro" && (
        <TextField
          fullWidth
          label="Especifica la ciudad"
          name="customExtraCity"
          value={customExtraCity}
          onChange={handleChange}
        />
      )}

      <Button
        onClick={handleAddExtraCity}
        variant="contained"
        startIcon={<AddCircleOutline />}
        className="mt-2 bg-purple-600 hover:bg-purple-700 text-white"
      >
        Añadir ciudad
      </Button>

      <div className="flex flex-wrap gap-2 pt-2">
        {selectedExtraCities.map((city) => (
          <div key={city}>
            <Chip
              label={city}
              onDelete={() => handleRemoveExtraCity(city)}
              color="secondary"
              className="shadow-lg hover:scale-105 transition-transform"
            />
          </div>
        ))}
      </div>
    </>
  );
}
